import React, { Component } from 'react';
import { displayUnits } from '../globals'
import { getReduxStore } from '../globals';
import CircleX from '../images/circle-x.png';
import '../css/common.css';
import '../css/shop_list_item_row.css';

export const ShopListItemSection = ({sectionHdr, indexKey}) => {
    return (
      <li className="shopListItemSectionHdr ultra-light-bk main-font" key={indexKey}>
        {sectionHdr}
      </li>
    );
  };  

export class ShopListItemRow extends Component {

    _timeoutID;

    constructor(props) {
        super(props);

        this.state = {item: this.props.item, selected: false, isDirty: false }

        this.setSelected = this.setSelected.bind(this);
    }

    componentDidMount() {
  
    }

    itemSelected() {
        this.setState({selected : !this.state.selected});
    }

    itemRemoved() {
        this.setState({selected : !this.state.selected});
        this.props.itemRemoved(this.state.item);
    }

    async qtyChanged(evt) {
        evt.persist();

        var n = parseFloat(evt.target.value);
        if (isNaN(n)) { n = ''; }
        await this.setState(prevState => ({
            item: {                   
                ...prevState.item,   
                Quantity: n
            },
            isDirty: true
        }));
    }

    async measureChanged(evt) {
        evt.persist();
        await this.setState(prevState => ({
            item: {
                ...prevState.item,
                Measurement_Id: evt.target.value,
                Measurement: evt.target.options[evt.target.selectedIndex].text
            },
            isDirty: true
        }));
    }

    setSelected () {
        this.setState({selected: true});
    }

    setUnSelected () {
        this.setState({selected: false});
    }

    onBlur(evt) {
        this._timeoutID = setTimeout(() => {
          if (this.state.selected) {
            this.setState({
              selected: false,
            });
          }
          if (this.state.isDirty) {
            this.props.shopListItemChanged(this.state.item);
            this.setState({
                isDirty: false,
              });  
          }
        }, 0);
      }
      
      onFocus(evt) {
        clearTimeout(this._timeoutID);
        if (!this.state.selected) {
          this.setState({
            selected: true,
          });
        }
    }
    

    addSelectedItemFields() {
        return (
            <div id="divSelectedFields">
                <div id="divQtySection">
                    <input 
                        id="inpQty"
                        type="number"
                        value={displayUnits(this.state.item.Quantity)}
                        autoFocus
                        onChange={this.qtyChanged.bind(this)} 
                    />
                </div>
                <div id="divMeasureSection">
                    <select 
                        id="cbxMeas" 
                        value={this.state.item.Measurement_Id}
                        onChange={this.measureChanged.bind(this)}
                    >
                        { 
                            getReduxStore().getState().ref_data.measure_list.map((m, i ) => {
                                return (
                                    <option key={m.Measurement_Id} value={m.Measurement_Id}>{m.Measurement_Code}</option>
                                )
                            })
                        }
                    </select>
                </div>
            </div>
        )
    }

    render() {

        const bkClass = this.props.evenRow ? 'main-font' : 'main-font ultra-ultra-light-bk';
      
        return (
            <div id="divShopListItemRowMain" onBlur={this.onBlur.bind(this)} onFocus={this.onFocus.bind(this)} className={bkClass}>
                <div id="divShopListItemRowNameArea">{this.props.item.Item_Name}</div>
                { 
                    (this.state.selected) ?  
                        this.addSelectedItemFields()
                    :
                        <div id="divQtyMeasure" className="lt-blue-font" onClick={this.setSelected}>
                            <div id="divQty">{displayUnits(this.state.item.Quantity)}</div>
                            <div id="divMeasure">{this.state.item.Measurement}</div>
                        </div>
                } 
                <div id="divEditBtns">
                    <img 
                        className="imgShopListItemRowBtns"
                        onClick={this.itemSelected.bind(this)}
                        style={{width: 22, height: 22}}
                        src={CircleX}
                        alt="" 
                        title="Delete Item" 
                    />
                </div>
            </div>
        )
    }

   }
   


// WEBPACK FOOTER //
// ./src/components/shop_list_item_row.js